import React from "react";
import {
    AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader,
    AlertDialogBody, AlertDialogFooter, Button, HStack, Text, Box, Badge,
    useToast,
} from "@chakra-ui/react";
import { AlertTriangle, Phone, Power } from "lucide-react";
import { useSoftphone } from "../contexts/softphone";

const SoftphoneAlerts = () => {
    const sp = useSoftphone();
    const cancelRef = React.useRef();
    const toast = useToast();

    React.useEffect(() => {
        if (sp.overrideDetected) {
            toast({
                status: "warning",
                title: "Ramal SIP foi desconectado",
                description: "Outro dispositivo pode ter entrado neste ramal. Clique em 'Reconectar' pra voltar.",
                duration: 8000,
                isClosable: true,
            });
        }
    }, [sp.overrideDetected, toast]);

    const confirmar = () => {
        sp.connect(true);
    };

    return (
        <>
            {/* Modal: ramal já em uso */}
            <AlertDialog
                isOpen={!!sp.pendingConfirm}
                onClose={sp.cancelPendingConfirm}
                leastDestructiveRef={cancelRef}
                isCentered
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="md">
                            <HStack>
                                <AlertTriangle size={18} color="#ea580c" />
                                <Text>Ramal já está em uso</Text>
                            </HStack>
                        </AlertDialogHeader>
                        <AlertDialogBody>
                            <Text fontSize="sm" color="gray.700" mb={3}>
                                Este ramal SIP está conectado em outro dispositivo (status do ramal: <Badge colorScheme="green" fontSize="10px">{sp.pendingConfirm?.status || "Online"}</Badge>).
                            </Text>
                            <Text fontSize="sm" color="gray.700" mb={3}>
                                Se você continuar, o outro dispositivo será <b>desconectado</b> e ficará sem receber chamadas.
                            </Text>
                            <Box bg="orange.50" border="1px solid" borderColor="orange.200" p={3} borderRadius="md">
                                <Text fontSize="xs" color="orange.800">
                                    Em geral isso acontece quando outro atendente está usando o mesmo ramal no MicroSIP/celular/outra aba.
                                </Text>
                            </Box>
                        </AlertDialogBody>
                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={sp.cancelPendingConfirm} size="sm" mr={2}>
                                Cancelar
                            </Button>
                            <Button colorScheme="orange" size="sm" leftIcon={<Power size={14} />} onClick={confirmar}>
                                Conectar mesmo assim
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    );
};

export default SoftphoneAlerts;
